<template>
  <div class="w-full z-50 absolute">
    <nav
      :class="[
        'navigation-bar w-full transition-colors duration-300',
        { 'nav-open-bg': showItemsOnMobile }
      ]"
    >
      <div class="nav-inner flex items-center justify-between py-3 relative">
        <router-link :to="{ name: 'home' }" class="flex items-center z-50">
          <app-image
            url="logo.png"
            is-local
            alt="Pinguinitos logo"
            class="max-w-none"
            width="165"
            height="60"
          />
        </router-link>

        <hamburger
          class="block lg:hidden z-50 relative"
          :open="showItemsOnMobile"
          @click.stop="toggleDrawer"
          alt="Menu"
        />

        <div class="hidden lg:flex lg:flex-row lg:items-center lg:justify-end">
          <div v-if="!authenticatedUser" :class="navItemLayoutClass">
            <router-link
              :to="{ name: 'login' }"
              :class="['login-text', navItemTextClass]"
            >
              {{ $config('LOGIN') || 'Iniciar sesión' }}
            </router-link>
          </div>

<!--          <div :class="navItemLayoutClass">-->
<!--            <div class="relative inline-flex flex-col items-center">-->
<!--              <button-->
<!--                :class="[navItemTextClass, 'lang-toggle']"-->
<!--                @click="toggleLangMenu"-->
<!--              >-->
<!--                {{ currentLang }}-->
<!--                <svg-->
<!--                  xmlns="http://www.w3.org/2000/svg"-->
<!--                  class="h-4 w-4 ml-1 inline transition-transform duration-200"-->
<!--                  :class="{ 'rotate-180': langMenuOpen }"-->
<!--                  fill="none"-->
<!--                  viewBox="0 0 24 24"-->
<!--                  stroke="currentColor"-->
<!--                >-->
<!--                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"-->
<!--                        d="M19 9l-7 7-7-7"/>-->
<!--                </svg>-->
<!--              </button>-->

<!--              <transition name="fade">-->
<!--                <ul v-if="langMenuOpen" class="lang-dropdown">-->
<!--                  <li-->
<!--                    v-for="lang in languages"-->
<!--                    :key="lang.code"-->
<!--                    @click="changeLang(lang.code)"-->
<!--                    class="px-4 py-2 text-white hover:bg-[#28d4ff]/30 cursor-pointer text-center"-->
<!--                  >-->
<!--                    {{ lang.label }}-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </transition>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>

      <transition name="fade">
        <div
          v-if="showItemsOnMobile"
          class="mobile-drawer"
        >
          <div v-if="!authenticatedUser" :class="navItemLayoutClass">
            <router-link
              :to="{ name: 'login' }"
              :class="['login-text', navItemTextClass]"
              @click="closeDrawer"
            >
              {{ $config('LOGIN') || 'Iniciar sesión' }}
            </router-link>
          </div>

<!--          <div :class="navItemLayoutClass">-->
<!--            <div class="relative inline-flex flex-col items-center">-->
<!--              <button-->
<!--                :class="[navItemTextClass, 'lang-toggle']"-->
<!--                @click.stop="toggleLangMenu"-->
<!--              >-->
<!--                {{ currentLang }}-->
<!--                <svg-->
<!--                  xmlns="http://www.w3.org/2000/svg"-->
<!--                  class="h-4 w-4 ml-1 inline transition-transform duration-200"-->
<!--                  :class="{ 'rotate-180': langMenuOpen }"-->
<!--                  fill="none"-->
<!--                  viewBox="0 0 24 24"-->
<!--                  stroke="currentColor"-->
<!--                >-->
<!--                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"-->
<!--                        d="M19 9l-7 7-7-7"/>-->
<!--                </svg>-->
<!--              </button>-->

<!--              <transition name="fade">-->
<!--                <ul v-if="langMenuOpen" class="lang-dropdown">-->
<!--                  <li-->
<!--                    v-for="lang in languages"-->
<!--                    :key="lang.code"-->
<!--                    @click="changeLang(lang.code)"-->
<!--                    class="px-4 py-2 text-white hover:bg-[#28d4ff]/30 cursor-pointer text-center"-->
<!--                  >-->
<!--                    {{ lang.label }}-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </transition>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </transition>
    </nav>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Hamburger from "./Hamburger";

export default {
  name: "NavigationLegacy",
  components: { Hamburger },
  data() {
    return {
      showItemsOnMobile: false,
      langMenuOpen: false,
      currentLang: this.$store.state.lang.toUpperCase(),
      languages: [
        { code: "es", label: "Español" },
        { code: "en", label: "English" }
      ]
    };
  },
  computed: {
    ...mapState(["authenticatedUser"]),
    navItemLayoutClass() {
      return "flex flex-col items-center text-center my-3";
    },
    navItemTextClass() {
      return "font-primary text-white whitespace-nowrap";
    }
  },
  methods: {
    toggleDrawer() {
      this.showItemsOnMobile = !this.showItemsOnMobile;
    },
    closeDrawer() {
      this.showItemsOnMobile = false;
      this.langMenuOpen = false;
    },
    toggleLangMenu() {
      this.langMenuOpen = !this.langMenuOpen;
    },
    async changeLang(code) {
      this.currentLang = code.toUpperCase();
      this.$store.commit("SET_LANG", code);
      window.location.reload();
    }
  },
  watch: {
    $route() {
      this.closeDrawer();
    }
  }
};
</script>

<style scoped lang="scss">
:root {
  --nav-height: 80px;
}

.navigation-bar {
  min-height: var(--nav-height);
  line-height: 0;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform: translateZ(0);
}

.nav-inner {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding-inline: clamp(16px, 4vw, 48px);
  box-sizing: border-box;
}

.mobile-drawer {
  position: absolute;
  top: calc(var(--nav-height) - 10px);
  left: 0;
  width: 100%;
  padding: 32px 16px;
  background-color: #025b8c;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -1px;
  overflow: hidden;
  height: auto;
  min-height: calc(100% + 12rem);
}

.nav-open-bg {
  background-color: #025b8c !important;
}

.font-primary {
  font-family: "Encode Sans Semi Expanded", sans-serif;
  font-size: 1.325rem;
  font-weight: 500;
}

.login-text {
  font-family: "Encode Sans Semi Expanded", sans-serif;
  font-size: 22px;
  color: #fff;
  padding: 0.625rem 2rem;
  text-decoration: none;
}

.lang-toggle {
  color: #fff;
  transition: color 0.25s ease;
}

.lang-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  width: 170px;
  padding: 4px 0;
  background-color: #025b8c;
  border-radius: 6px;
  border: 1px solid rgba(255,255,255,.15);
  box-shadow: 0 6px 14px rgba(0,0,0,.35);
  display: flex;
  flex-direction: column;
  z-index: 9999;
}

.lang-dropdown li {
  width: 100%;
  padding: 10px 20px;
  font-family: "Encode Sans Semi Expanded", sans-serif;
  font-size: 22px;
  line-height: 1.35rem;
  white-space: nowrap;
  color: #fff;
  transition: background .2s ease;
}

.lang-dropdown li:hover {
  background: rgba(40,212,255,.25);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.navigation-bar *,
.mobile-drawer * {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>